// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.result-wrapper {
  margin: -60px 40px 40px 40px;
  position: relative !important;
  padding: 2em;
  background-color: #fff;
}

.hw-container-background {
  margin: -60px 40px 0px 40px;
}

@media screen and (max-width: 840px) {
  .hw-container-background {
    margin: -60px 0px 0px 0px;
    padding: 1em;
  }
}
.header-line {
  font-weight: 500;
  font-family: "Roboto";
  font-size: 11px;
}

.mat-mdc-row {
  height: 40px;
  width: 100%;
}

.group-header {
  background-color: #f5f5f5 !important;
  font-weight: 500;
}

.th-header {
  background-color: #585858 !important;
  color: white;
}

/* Alapértelmezésben az asztali nézet aktív */
.desktop-view {
  display: block;
}

.mobile-view {
  display: none;
}

.desktop-view {
  display: block;
}

.mobile-view {
  display: none;
  padding: 1rem;
}

.mobile-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1rem;
  background-color: white;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}

.mobile-row {
  padding: 0.5em 1em 0.5em 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobil nézet váltása */
@media screen and (max-width: 768px) {
  .desktop-view {
    display: none !important;
  }
  .mobile-view {
    display: block !important;
  }
}
.mobile-center-align {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mat-expansion-panel-header {
  height: initial;
  min-height: 56px;
  padding-bottom: 0.5em;
}

.mat-expansion-panel:not(.mat-expanded):not([aria-disabled=true]) .mat-expansion-panel-header:hover {
  background: #fff;
  height: initial;
  min-height: 56px;
}

@media (max-width: 768px) {
  .group-highlight {
    background-color: #cdcdcd;
    border-radius: 4px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
